// extracted by mini-css-extract-plugin
export default {"numberingModal_card":"ItemNumberingModal_numberingModal_card__-rlem"};